<template>
  <div>
    <!--  标题及按钮  -->
    <mtd-row class="margin-bottom-0">
      <mtd-col :span="12" class="height-full">
        <span class="page-title-32">{{ $getText('wenshu_web_subordinate_forwarding_records', '下属外发记录') }}</span>
      </mtd-col>
      <mtd-col :span="12" class="margin-bottom-0 text-right">
        <mtd-button type="primary" @click="open_message_setting" style="margin-right: 0; width: 82px;">{{ $getText('wenshu_web_settings', '设置') }}</mtd-button>
      </mtd-col>
    </mtd-row>
    <!--  关键字检索  -->
    <mtd-row style="margin-top: 12px;">
      <mtd-col :span="24" class="policy-search-block">
        <mtd-form inline :label-width="120">
          <mtd-row :gutter="16">
            <mtd-col :span="8" style="padding-left: 0;">
              <mtd-form-item label="MISID:">
                <mtd-input type="text" style="width: 100%;" :placeholder="$getText('wenshu_web_please_enter_user_misid', '请输入用户MISID')"
                           v-model="search_form.creator" :clearable="true"/>
              </mtd-form-item>
            </mtd-col>
            <mtd-col :span="8">
              <mtd-form-item :label="$getText('wenshu_mobile_file_name', '文件名称:')">
                <mtd-input type="text" style="width: 100%;" :placeholder="$getText('wenshu_mobile_please_enter_file_name', '请输入文件名称')"
                           v-model="search_form.fileName" :clearable="true"/>
              </mtd-form-item>
            </mtd-col>
            <mtd-col :span="8" style="padding-right: 0;">
              <mtd-form-item :label="$getText('wenshu_mobile_application_time', '申请时间:')">
                <mtd-date-picker type="daterange" value-format="yyyy-MM-dd" clearable
                                 class="search_datetime_range" style="width: 100%;" :options="date_range_option"
                                 v-model="search_form.date_range"/>
              </mtd-form-item>
            </mtd-col>
            <mtd-col :span="8" :offset="16" style="padding-right: 0; text-align: right;">
              <mtd-button type="text-primary" style="width: 70px;" @click="reset_search_form">{{ $getText('wenshu_mobile_reset', '重置') }}</mtd-button>
              <mtd-button ghost type="primary" style="width: 80px;" @click="list_table_data">{{ $getText('wenshu_web_search', '搜索') }}</mtd-button>
            </mtd-col>
          </mtd-row>
        </mtd-form>
      </mtd-col>
    </mtd-row>
    <!--  表格数据  -->
    <div style="margin-top: 12px">
      <mtd-table size="small" :data="file_out_apply_list" reserve-selection :empty-text="$getText('wenshu_web_no_data', '暂无数据')">
        <mtd-table-column type="expand" width="40">
          <template slot-scope="scope">
            <div style="padding: 12px 40px;background-color: #F7F7F7;">
              <div class="file-content-div">
                <h2 class="apply-content">{{ $getText('wenshu_web_included_files', '包含的文件') }}</h2>
                <div v-for="item in scope.row.fileNames" class="file-name">{{ item }}</div>
              </div>
              <div class="file-content-div">
                <h2 class="apply-content">{{ $getText('wenshu_web_external_process', '外发流程') }}</h2>
                <div class="file-name">{{ scope.row.strategyName || $getText('wenshu_web_approval_free', '免审批') }}</div>
              </div>
              <div class="file-content-div">
                <h2 class="apply-content">{{ $getText('wenshu_web_external_reason', '外发原因') }}</h2>
                <div class="file-name">{{ scope.row.reason || $getText('wenshu_web_none', '无') }}</div>
              </div>
              <div class="file-content-div">
                <h2 class="apply-content">{{ $getText('ws_mobile_send_out_email', '外发邮箱') }}</h2>
                <div class="file-name">{{ scope.row.emails || $getText('wenshu_web_none', '无') }}</div>
              </div>
              <div class="file-content-div">
                <h2 class="apply-content">{{ $getText('wenshu_web_file_share_link', '文件分享链接') }}</h2>
                <div class="file-name"><a :href="scope.row.downloadUrl" target="_blank">{{ scope.row.downloadUrl }}</a>
                </div>
              </div>
              <div class="file-content-div">
                <h2 class="apply-content">{{ $getText('wenshu_web_extraction_password', '提取密码') }}</h2>
                <div class="file-name">{{ scope.row.downloadPassword || $getText('wenshu_web_none', '无') }}</div>
              </div>
            </div>
          </template>
        </mtd-table-column>
        <mtd-table-column prop="creator" label="MISID" width="120"/>
        <mtd-table-column prop="id" :label="$getText('wenshu_web_application_number', '申请编号')"/>
        <mtd-table-column prop="fileNumber" :label="$getText('wenshu_mobile_number_of_files', '文件数量')" width="200">
          <template slot-scope="scope">
            <span>{{ scope.row.fileNames.length }}{{ $getText('wenshu_web_files', '个文件') }}</span>
          </template>
        </mtd-table-column>
        <mtd-table-column prop="checkStatus" :label="$getText('wenshu_web_approval_status', '审批状态')" width="100">
          <template slot-scope="scope">
            <!-- 审批中-->
            <div v-if="scope.row.status == 0">
              <i class='mtdicon mtdicon-time-o'
                 style="color: #0A70F5;margin-right: 4px;font-size: 16px;vertical-align: middle;"></i>
              <span style="vertical-align: middle;">{{ $getText('wenshu_web_under_approval', '审批中') }}</span>
            </div>
            <!-- 已通过-->
            <div v-if="scope.row.status == 1">
              <i class='mtdicon mtdicon-success-o'
                 style="color: #00b365;margin-right: 4px;font-size: 16px;vertical-align: middle;"></i>
              <span style="vertical-align: middle;">{{ $getText('wenshu_web_approved', '已通过') }}</span>
            </div>
            <!-- 已驳回-->
            <div v-if="scope.row.status == 2">
              <i class='mtdicon mtdicon-error-o'
                 style="color: #f5483b;margin-right: 4px;font-size: 16px;vertical-align: middle;"></i>
              <span style="vertical-align: middle;">{{ $getText('wenshu_web_rejected_1', '已驳回') }}</span>
            </div>
          </template>
        </mtd-table-column>
        <mtd-table-column prop="createTime" :label="$getText('wenshu_web_application_time', '申请时间')" width="180">
          <template slot-scope="scope">
            {{ scope.row.createTime|dateTimeFormat }}
          </template>
        </mtd-table-column>
        <mtd-table-column prop="createTime" :label="$getText('wenshu_web_link_expiration_time', '链接过期时间')" width="150">
          <template slot-scope="scope">
            <span v-if="scope.row.expireTime === 0">{{ $getText('wenshu_web_terminated', '已终止') }}</span>
            <span v-else>{{ scope.row.expireTime|dateTimeFormat }}</span>
          </template>
        </mtd-table-column>
        <mtd-table-column prop="operation" :label="$getText('wenshu_web_operation', '操作')" width="280">
          <template slot-scope="scope">
            <mtd-button type="text-primary" size="small" @click="open_abnormal_feedback(scope.row)"
                        style="padding-right: 12px;"
                        :disabled="scope.row.feedbackContent != null && scope.row.feedbackContent != ''">
              {{ $getText('wenshu_web_report_abnormal', '反馈异常') }}
            </mtd-button>
            <mtd-button type="text-primary" size="small"
                        v-clipboard:copy="copyMessage"
                        v-clipboard:success="copySuccess"
                        v-clipboard:error="copyError"
                        @click="copyUrl(scope.$index)"
                        style="padding-right: 12px;">{{ $getText('wenshu_web_copy_link', '复制链接') }}
            </mtd-button>
            <mtd-button type="text-primary" size="small" @click="check_process(scope.$index)"
                        style="padding-left: 0;padding-right: 12px;margin-right: 0"
                        :disabled="scope.row.bpmAddress == null || scope.row.bpmAddress === ''">{{ $getText('wenshu_web_approval_progress', '审批进度') }}
            </mtd-button>
            <mtd-button type="text-primary" size="small" @click="terminate_file_out(scope.row.id)"
                        style="padding-left: 0;padding-right: 0;margin-right: 0"
                        :disabled="scope.row.outOfDate || scope.row.isTerminated || scope.row.status !== 1">
                <span v-if="scope.row.isTerminated">{{ $getText('wenshu_web_forwarding_prohibited', '已禁止外发') }}</span>
                <span v-else>{{ $getText('wenshu_web_prohibit_forwarding', '禁止外发') }}</span>
            </mtd-button>
          </template>
        </mtd-table-column>
      </mtd-table>
      <mtd-pagination v-if="search_form.total > 10" :total="search_form.total" :show-total="true"
                      :current-page.sync="search_form.currentPage" @change="select_record_list()"
                      size="small" style="float: right;margin-top: 12px"/>
    </div>
    <!-- 消息通知设置弹窗 -->
    <mtd-modal :title="$getText('wenshu_web_settings', '设置')" width="50%" v-model="message_setting_visible" @close="close_message_setting">
      <mtd-form ref="message_setting_form" :model="message_setting_data">
        <mtd-tabs v-model="setting_active_tab">
          <mtd-tab-pane :label="$getText('wenshu_web_cc_notification', '抄送通知')" value="setting_notice_switch">
            <mtd-form-item :label="$getText('wenshu_web_no_approval_cc_notification', '免审批抄送通知:')" :label-width="200">
              <mtd-switch v-model="message_setting_data.message_notice_switch" size="small"
                          style="top: 6px;margin-right: 5px;"/>
            </mtd-form-item>
          </mtd-tab-pane>
          <mtd-tab-pane :label="$getText('wenshu_web_audit_cycle', '审计周期')" value="setting_send_cycle">
            <mtd-form-item :label="$getText('wenshu_web_forwarding_report_audit_report_cycle', '外发报备审计报告周期:')" :label-width="200">
              <mtd-select type="text" v-model="message_setting_data.report_send_cycle" style="width: 100px;">
                <mtd-option value="DAY" :label="$getText('wenshu_web_one_day', '一天')"/>
                <mtd-option value="WEEK" :label="$getText('wenshu_web_one_week', '一周')"/>
                <mtd-option value="MONTH" :label="$getText('wenshu_web_one_month', '一月')"/>
              </mtd-select>
            </mtd-form-item>
          </mtd-tab-pane>
        </mtd-tabs>
      </mtd-form>
      <div slot="footer" class="demo-modal-footer" style="padding-top: 12px;">
        <mtd-button @click="close_message_setting">{{ $getText('wenshu_mobile_cancel', '取消') }}</mtd-button>
        <mtd-button type="primary" @click="submit_message_setting">{{ $getText('wenshu_web_module_confirm', '确定') }}</mtd-button>
      </div>
    </mtd-modal>
    <!-- 异常反馈弹窗 -->
    <mtd-modal :title="$getText('wenshu_web_report_abnormal', '异常反馈')" width="600px" v-model="abnormal_feedback_visible" @close="close_abnormal_feedback">
      <mtd-form ref="abnormal_feedback_form" :model="feedback_form" :rules="feedbackRuleCustom">
        <mtd-form-item :label="$getText('wenshu_web_module_abnormal_reason', '异常原因:')" :label-width="72" prop="feedbackContent">
          <mtd-textarea v-model="feedback_form.feedbackContent" :placeholder="$getText('wenshu_web_module_fill_abnormal_reason', '请详细填写异常原因')"
                        style="width: 100%;resize: none; height: 160px;"/>
        </mtd-form-item>
      </mtd-form>
      <div slot="footer" class="demo-modal-footer">
        <mtd-button @click="close_abnormal_feedback">{{ $getText('wenshu_mobile_cancel', '取消') }}</mtd-button>
        <mtd-button type="primary" @click="submit_abnormal_feedback" :disabled="feedback_modal_valid">{{ $getText('wenshu_web_module_confirm', '确定') }}</mtd-button>
      </div>
    </mtd-modal>
  </div>
</template>

<script>

import {mapActions} from "vuex";
import moment from "moment";

export default {
  name: "file_out_list",
  filters: {
    dateTimeFormat(dateTime) {
      return moment(dateTime)
        .utcOffset(480)
        .format('YYYY-MM-DD HH:mm:ss');
    },
  },
  data() {
    const today = new Date();
    const shortcuts = [
      {
        text: this.$getText('wenshu_web_module_last_day', '最近一天'),
        value() {
          return [today, today];
        },
      },
      {
        text: this.$getText('wenshu_web_module_last_week', '最近一周'),
        value() {
          const oneWeek = new Date();
          oneWeek.setTime(today.getTime() - 3600 * 1000 * 24 * 7);
          return [oneWeek, today];
        },
      },
      {
        text: this.$getText('wenshu_web_module_last_month', '最近一月'),
        value() {
          const oneMonth = new Date();
          oneMonth.setTime(today.getTime() - 3600 * 1000 * 24 * 30);
          return [oneMonth, today]
        },
      },
    ];
    const validateFeedbackContent = (_rule, value, callback) => {
      if (!value || value === '') {
        return callback(new Error(this.$getText('wenshu_web_module_abnormal_reason_required', '异常原因不能为空')));
      }
      return callback();
    }
    return {
      date_range_option: {
        shortcuts
      },
      search_form: {
        keyword: '',
        creator: null,
        fileName: null,
        date_range: [],
        currentPage: 1,
        limit: 10,
        total: 0,
      },
      file_out_apply_list: [],
      copyMessage: '',
      open_directly_tab: null,
      setting_active_tab: 'setting_notice_switch',
      message_setting_visible: false,
      old_message_setting_data: {
        message_notice_switch: true,
        report_send_cycle: 'DAY'
      },
      message_setting_data: {
        message_notice_switch: true,
        report_send_cycle: 'DAY'
      },
      current_row_save: null,
      abnormal_feedback_visible: false,
      feedback_form: {
        feedbackContent: null,
      },
      feedbackRuleCustom: {
        feedbackContent: [
          {validator: validateFeedbackContent, trigger: 'blur'},
        ]
      }
    }
  },
  computed: {
    feedback_modal_valid() {
      if (!this.feedback_form.feedbackContent || this.feedback_form.feedbackContent === '') {
        return true;
      }
      return false;
    }
  },
  mounted() {
    let query_params = this.$route.query;
    if (query_params) {
      let {creator, startTime, endTime, settingFunction} = query_params;
      if (creator && creator !== '') {
        this.search_form.creator = creator;
      }
      let date_range = [];
      if (startTime && /^\d{4}\-\d{2}\-\d{2}$/.test(startTime)) {
        date_range.push(startTime)
      }
      if (endTime && /^\d{4}\-\d{2}\-\d{2}$/.test(endTime)) {
        date_range.push(endTime)
      }
      if (date_range.length === 2) {
        this.search_form.date_range = date_range;
      }
      if (settingFunction && settingFunction !== '') {
        this.open_directly_tab = settingFunction;
      }
    }
    this.select_record_list();
    this.load_superior_setting();
  },
  methods: {
    ...mapActions([
      'querySubordinateFileOutRecordList',
      'querySuperiorSetting',
      'submitSuperiorSetting',
      'submitRecordSuperiorFeedback',
      'terminateFileOutByOthers',
    ]),
    select_record_list() {
      if (this.search_form.date_range.length === 2) {
        this.search_form.startTime = this.search_form.date_range[0] + " 00:00:00";
        this.search_form.endTime = this.search_form.date_range[1] + " 23:59:59";
      } else {
        this.search_form.startTime = null;
        this.search_form.endTime = null;
      }
      this.querySubordinateFileOutRecordList(this.search_form).then(res => {
        this.file_out_apply_list = res.data.items;
        this.search_form.total = res.data.total;
      })
    },
    list_table_data() {
      this.search_form.currentPage = 1;
      this.select_record_list();
    },
    copyUrl(index) {
      let url = this.file_out_apply_list[index].downloadUrl;
      let password = this.file_out_apply_list[index].downloadPassword;
      let info = this.$getText('ws_mobile_file_share_link_text', '文件分享链接：') + url + '\n' + this.$getText('wenshu_web_module_extraction_password', '提取密码:') + password;
      this.copyMessage = info;
    },
    copySuccess() {
      this.$mtd.message({
        message: this.$getText('ws_mobile_copy_success_to_clipborad', '链接已复制到剪切板'),
        type: 'success',
      });
    },
    copyError() {
      this.$mtd.message({
        message: this.$getText('wenshu_web_module_copy_failed', '复制失败'),
        type: 'error',
      });
    },
    back_to_file_out() {
      this.$router.push({path: "file_upload"});
    },
    check_process(id) {
      let url = this.file_out_apply_list[id].bpmAddress;
      window.open(url);
    },
    terminate_file_out(id) {
      this.terminateFileOutByOthers({id: id}).then(res => {
        if (res.code === 0) {
          this.$mtd.message.success(this.$getText('wenshu_web_module_prohibit_forwarding_success', '禁止外发成功'));
        } else {
          this.$mtd.message.error(res.message);
        }
        this.list_table_data();
      }).catch(err => {
        this.$mtd.message.error(this.$getText('wenshu_web_module_prohibit_forwarding_failed', '禁止外发失败'));
      })
    },
    reset_search_form() {
      this.search_form = {
        keyword: '',
        creator: null,
        fileName: null,
        date_range: [],
        currentPage: 1,
        limit: 10,
        total: 0,
      }
    },
    load_superior_setting() {
      this.querySuperiorSetting({}).then((res) => {
        let data = res.data;
        if (data) {
          let {messageNoticeSwitch, reportSendCycle} = data;
          this.old_message_setting_data = {
            message_notice_switch: messageNoticeSwitch,
            report_send_cycle: reportSendCycle
          }
          this.message_setting_data = {
            message_notice_switch: messageNoticeSwitch,
            report_send_cycle: reportSendCycle
          }
          // 判断一下是否直接打开页面
          if (this.open_directly_tab && this.open_directly_tab !== '') {
            this.setting_active_tab = this.open_directly_tab;
            this.open_message_setting();
          }
          this.open_directly_tab = null;
        }
      })
    },
    // 外发通知消息设置
    open_message_setting() {
      this.message_setting_visible = true;
    },
    close_message_setting() {
      this.message_setting_visible = false;
      // 重新加载配置数据
      this.load_superior_setting();
      this.setting_active_tab = 'setting_notice_switch';
      this.open_directly_tab = null;
    },
    submit_message_setting() {
      let {message_notice_switch, report_send_cycle} = this.message_setting_data;
      let form_data = {messageNoticeSwitch: message_notice_switch, reportSendCycle: report_send_cycle};
      this.submitSuperiorSetting(form_data).then(() => {
        this.$mtd.message.success(this.$getText('wenshu_web_module_set_submit_success', '设置提交成功'));
        this.close_message_setting();
      });
    },
    open_abnormal_feedback(row) {
      this.current_row_save = row;
      this.abnormal_feedback_visible = true;
    },
    close_abnormal_feedback() {
      this.current_row_save = null;
      this.abnormal_feedback_visible = false;
      this.feedback_form = {
        feedbackContent: null
      }
      let form_ref = this.$refs['abnormal_feedback_form']
      form_ref.clearValidate();
      this.select_record_list();
    },
    submit_abnormal_feedback() {
      let form_ref = this.$refs['abnormal_feedback_form']
      form_ref.validate((result) => {
        if (!result) {
          return
        }
        let form_data = {};
        form_data['recordId'] = this.current_row_save.id;
        form_data['recordCreator'] = this.current_row_save.creator;
        form_data['feedbackContent'] = this.feedback_form.feedbackContent;
        this.submitRecordSuperiorFeedback(form_data).then(() => {
          this.$mtd.message.success(this.$getText('wenshu_web_module_abnormal_feedback_success', '异常反馈成功'));
          this.close_abnormal_feedback();
        });
      });
    }
  }
}
</script>

<style>
@import "../../../styles/reset_table.css";

.margin-bottom-0 {
  margin-bottom: 0;
}

h2.dd-page-title {
  font-size: 20px;
  color: rgba(0, 0, 0, 0.84);
  line-height: 32px;
  margin-bottom: 16px;
}

h2.apply-content {
  font-size: 14px;
  line-height: 22px;
  margin-bottom: 12px;
}

.mtd-table-cell {
  font-size: 12px;
}

.mtd-table .mtd-table-expanded-cell {
  padding: 0 !important;
}

.mtd-table-expanded-cell > .mtd-table-cell {
  height: auto;
}

.file-name {
  font-size: 14px;
  margin-bottom: 8px;
}

.file-content-div {
  margin-bottom: 12px;
}

.mtd-btn-small {
  padding: 0;
}

.mtd-message {
  min-width: 20px;
  padding: 6px 16px;
}

.policy-search-block .mtd-form-item {
  width: 100%;
}

.policy-search-block {
  background: #F7F7F7;
  padding: 12px 16px;
}
</style>
